
import { Component, Mixins } from "vue-property-decorator";
import { Point, Size, Rectangle } from "../../../../../../../base/domain/drawing";
import { IRectangleCoordinateEditable } from "../../../../../../domain/editableFormat/properties";
import { LocationPropertyEditableMixin, SizePropertyEditableMixin } from "../../../mixins";

@Component
export default class RectangleCoordinateEditableMixin extends Mixins(LocationPropertyEditableMixin, SizePropertyEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IRectangleCoordinateEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IRectangleCoordinateEditable) => T, defaultValue: T) => T;

  get isRectangleCoordinateEditable(): boolean {
    return this.isLocationEditable
        && this.isSizeEditable;
  }

  get rectangleCoordinate(): Rectangle {
    return new Rectangle(this.location, this.size);
  }

  set rectangleCoordinate(value: Rectangle) {
    this.writePropertyWhenValid(s => {
      s.location().setValue(Point.to(value.topLeft));
      s.size().setValue(Size.to(value.size));
    });
  }

  get topLeft(): Point {
    return this.readPropertyOrDefault(s => Point.from(s.topLeft().getValue()), new Point(0, 0));
  }

  set topLeft(value: Point) {
    this.writePropertyWhenValid(s => s.topLeft().setValue(Point.to(value)));
  }

  get center(): Point {
    return this.readPropertyOrDefault(s => {
      s.center().getValue();
      return Point.from(s.center().getValue());
    }, new Point(0, 0));
  }

  set center(value: Point) {
    this.writePropertyWhenValid(s => s.center().setValue(Point.to(value)));
  }

  get bottomRight(): Point {
    return this.readPropertyOrDefault(s => Point.from(s.bottomRight().getValue()), new Point(0, 0));
  }

  set bottomRight(value: Point) {
    this.writePropertyWhenValid(s => s.bottomRight().setValue(Point.to(value)));
  }
}
